import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-4"
}
const _hoisted_2 = { class: "fv-row mb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2" }, " Comment ", -1)

import { computed, ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import { Field, ErrorMessage, useForm } from "vee-validate";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmCommentBox',
  props: {
    handleSubmit: { type: Function }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const simpleFormRef = ref<InstanceType<typeof SimpleForm>>();
const isLoading = ref(true);
const submited = ref(false);
const formData = ref({} as any);

const validationSchema = {
  comment: "required",
};

const { handleSubmit, resetForm } = useForm({
  validationSchema,
});
const { t } = useI18n();

const confirmationText = ref<any>(null);
const confirmationTitle = ref<any>(null);
const cancelButtonText = ref<any>(null);
const submitButtonText = ref<any>(null);

const handleHandleSubmit = ref(props.handleSubmit ?? (() => Promise.reject()));
const displayConfirmationTitle = computed(
  () => confirmationTitle.value ?? t("title.reject")
);

const displayConfirmationText = computed(() => confirmationText.value ?? "");

const displayCancelButtonText = computed(
  () => cancelButtonText.value ?? t("action.cancel")
);

const displaySubmitButtonText = computed(
  () => submitButtonText.value ?? t("action.confirm")
);

const submit = handleSubmit(async () => {
  isLoading.value = true;
  try {
    await handleHandleSubmit.value(formData.value);
    submited.value = true;
    simpleFormRef.value?.hide();
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
});

const close = () => {
  simpleFormRef.value?.hide();
};

const show = async (
  _handler?: (form: any) => Promise<any>,
  _confirmationText?: string,
  _confirmationTitle?: string,
  _cancelButtonText?: string,
  _submitButtonText?: string
) => {
  // demoAccountCreateRef.value?.hide();
  if (_handler) {
    handleHandleSubmit.value = _handler;
  }
  if (_confirmationText) {
    confirmationText.value = _confirmationText;
  }
  if (_confirmationTitle) {
    confirmationTitle.value = _confirmationTitle;
  }
  if (_cancelButtonText) {
    cancelButtonText.value = _cancelButtonText;
  }
  if (_submitButtonText) {
    submitButtonText.value = _submitButtonText;
  }

  simpleFormRef.value?.show();
  isLoading.value = true;
  submited.value = false;
  formData.value = {
    comment: "Withdrawal ",
  };

  // resetForm({ values: {} });

  isLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(SimpleForm, {
    submit: _unref(submit),
    discard: close,
    title: _ctx.$t('title.confirm'),
    isLoading: isLoading.value,
    submitted: submited.value,
    saveTitle: displaySubmitButtonText.value,
    "discard-title": displayCancelButtonText.value,
    submitColor: "success",
    elId: "liveAccountCreate",
    ref_key: "simpleFormRef",
    ref: simpleFormRef
  }, {
    default: _withCtx(() => [
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _createVNode(_unref(Field), {
                  modelValue: formData.value.comment,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.comment) = $event)),
                  name: "comment"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.comment,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.comment) = $event)),
                      name: "comment",
                      type: "textarea",
                      placeholder: _ctx.$t('tip.enterComment')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_unref(ErrorMessage), {
                  class: "fv-plugins-message-container invalid-feedback",
                  name: "comment",
                  as: "div"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("tip.requiredField")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["submit", "title", "isLoading", "submitted", "saveTitle", "discard-title"]))
}
}

})